import { Box, Grid, Skeleton, Typography } from "@mui/material";
import Logo from "../core/layout/header-section/components/Logo";

const HeaderSkeleton = () => {
  return (
    <>
      <Box
        sx={{
          position: "sticky",
          top: 0,
          bgcolor: "background.default",
          zIndex: 1000,
          display: { xs: "block", md: "none" },
          width: { xs: "100%", md: "80%" },
          margin: "auto",
          py: 1,
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Grid container>
            <Logo width={96} height={40} handleLogoClick={() => {}} />
            {/* <BoltLogo sx={{ my: "1.5rem" }} /> */}
          </Grid>
          <Box
            sx={{
              margin: "0 1rem",
            }}
          >
            <Skeleton
              animation="wave"
              variant="rounded"
              sx={{ height: "2rem", width: "2rem" }}
            />
          </Box>
        </Box>
      </Box>
      {/* Desktop View Header */}
      <Box
        sx={{
          display: { xs: "none", md: "block" },
          bgcolor: "background.default",
          position: "sticky",
          top: 0,
          zIndex: 1000,
          borderBottom: "1px solid",
          borderColor: "color.aigColor68",
          py: 1,
        }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            width: { xs: "100%", md: "80%" },
            margin: "auto",
            color: "color.aigColor11",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Logo width={96} height={40} handleLogoClick={() => {}} />
            {/* <BoltLogo sx={{ my: "1.5rem" }} /> */}

            <>
              <Typography
                variant="headerLinkStyle"
                component="span"
                sx={{
                  marginLeft: "2rem",
                }}
              >
                <Skeleton
                  animation="wave"
                  variant="text"
                  sx={{ fontSize: "2rem", width: "3rem" }}
                />
              </Typography>
              <Typography
                variant="headerLinkStyle"
                component="span"
                sx={{
                  marginLeft: "1.6rem",
                }}
              >
                <Skeleton
                  animation="wave"
                  variant="text"
                  sx={{ fontSize: "2rem", width: "8rem" }}
                />
              </Typography>
            </>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <>
              <Skeleton
                variant="rounded"
                animation="wave"
                width={40}
                height={40}
                sx={{ mr: 7 }}
              />

              <Skeleton
                variant="circular"
                animation="wave"
                width={40}
                height={40}
              />
            </>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default HeaderSkeleton;
